

import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

const FAQAccordion = () => {
  const { t } = useTranslation();

  // State to track which sections are open
  const [openSections, setOpenSections] = useState({
    distributors: true,
    distributorProgram: true,
    requirements: false,
    eligibleCompanies: false,
    support: false,
    exclusivity: false,
    investment: false,
    agreementDuration: false,
    channelPartners: false,
    resellerPartners: false,
  });

  // Toggle function for sections
  const toggleSection = (section) => {
    setOpenSections({
      ...openSections,
      [section]: !openSections[section],
    });
  };

  return (
    <div className="bg-black/5 py-8">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          {t("Frequently Asked Questions")}
        </h1>

        <div className=" rounded-lg shadow-sm overflow-hidden  bg-white border">
          {/* For Distributors Section */}
          <div className="border-b border-gray-100 ">
            <button
              className="w-full flex justify-between items-center p-4 text-left bg-blue-50 hover:bg-blue-100 transition-colors"
              onClick={() => toggleSection("distributors")}
            >
              <h2 className="text-lg font-medium text-gray-800">
                {t("For Distributors")}
              </h2>
              <span>
                {openSections.distributors ? (
                  <ChevronUp className="h-5 w-5 text-gray-500" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-gray-500" />
                )}
              </span>
            </button>

            {openSections.distributors && (
              <div className="border-t border-gray-100">
                {/* How does yslearn's Distributor Partner Program work? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("distributorProgram")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "How does yslearn's Distributor Partner Program work?"
                      )}
                    </h3>
                    <span>
                      {openSections.distributorProgram ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.distributorProgram && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t(
                          "Distributors partner with yslearn to be the exclusive online seller of our training courses in a given region."
                        )}
                      </p>
                    </div>
                  )}
                </div>

                {/* What are the requirements to sign up as a yslearn distributor? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("requirements")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "What are the requirements to sign up as a yslearn distributor?"
                      )}
                    </h3>
                    <span>
                      {openSections.requirements ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.requirements && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t("Requirements information would be displayed here.")}
                      </p>
                    </div>
                  )}
                </div>

                {/* What type of companies are eligible to become a distributor? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("eligibleCompanies")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "What type of companies are eligible to become a distributor?"
                      )}
                    </h3>
                    <span>
                      {openSections.eligibleCompanies ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.eligibleCompanies && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t(
                          "Eligible companies information would be displayed here."
                        )}
                      </p>
                    </div>
                  )}
                </div>

                {/* What kind of support will we receive from yslearn? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("support")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "What kind of support will we receive from yslearn?"
                      )}
                    </h3>
                    <span>
                      {openSections.support ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.support && (
                    <div className="p-4 text-gray-700">
                      <p>{t("Support information would be displayed here.")}</p>
                    </div>
                  )}
                </div>

                {/* What types of exclusivity are provided? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("exclusivity")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t("What types of exclusivity are provided?")}
                    </h3>
                    <span>
                      {openSections.exclusivity ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.exclusivity && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t("Exclusivity information would be displayed here.")}
                      </p>
                    </div>
                  )}
                </div>

                {/* What is the amount of investment required to sign up? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("investment")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "What is the amount of investment required to sign up?"
                      )}
                    </h3>
                    <span>
                      {openSections.investment ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.investment && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t("Investment information would be displayed here.")}
                      </p>
                    </div>
                  )}
                </div>

                {/* What are the minimum and maximum agreement duration for a distributor? */}
                <div className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSection("agreementDuration")}
                  >
                    <h3 className="font-medium text-gray-800">
                      {t(
                        "What are the minimum and maximum agreement duration for a distributor?"
                      )}
                    </h3>
                    <span>
                      {openSections.agreementDuration ? (
                        <ChevronUp className="h-5 w-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-500" />
                      )}
                    </span>
                  </button>

                  {openSections.agreementDuration && (
                    <div className="p-4 text-gray-700">
                      <p>
                        {t(
                          "Agreement duration information would be displayed here."
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* For Channel Partners */}
          <div className="border-b border-gray-100">
            <button
              className="w-full flex justify-between items-center p-4 text-left bg-blue-50 hover:bg-blue-100 transition-colors"
              onClick={() => toggleSection("channelPartners")}
            >
              <h2 className="text-lg font-medium text-gray-800">
                {t("For Channel Partners")}
              </h2>
              <span>
                {openSections.channelPartners ? (
                  <ChevronUp className="h-5 w-5 text-gray-500" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-gray-500" />
                )}
              </span>
            </button>

            {openSections.channelPartners && (
              <div className="p-4 text-gray-700">
                <p>
                  {t("Channel partners information would be displayed here.")}
                </p>
              </div>
            )}
          </div>

          {/* For Reseller & Referral Partners */}
          <div>
            <button
              className="w-full flex justify-between items-center p-4 text-left bg-blue-50 hover:bg-blue-100 transition-colors"
              onClick={() => toggleSection("resellerPartners")}
            >
              <h2 className="text-lg font-medium text-gray-800">
                {t("For Reseller & Referral Partners")}
              </h2>
              <span>
                {openSections.resellerPartners ? (
                  <ChevronUp className="h-5 w-5 text-gray-500" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-gray-500" />
                )}
              </span>
            </button>

            {openSections.resellerPartners && (
              <div className="p-4 text-gray-700">
                <p>
                  {t(
                    "Reseller and referral partners information would be displayed here."
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQAccordion;
